export default __webpack_public_path__ + "static/media/icon-agent-region.cf58315d.svg";